import React from 'react';
import { StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import theme from 'shared/styles/theme';

function MapLoadingIndicator() {
  return (
    <View
      style={styles.loadingContainer}
      accessible
      aria-label="Map markers loading"
    >
      <View style={styles.loadingOverlay}>
        <LoadingSpinner />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  loadingContainer: {
    position: 'absolute',
    zIndex: 1,
  },
  loadingOverlay: {
    alignItems: 'center',
    backgroundColor: theme.color.background.overlay,
    borderRadius: 8,
    display: 'flex',
    height: 80,
    justifyContent: 'center',
    width: 80,
    zIndex: 2,
  },
});

export default MapLoadingIndicator;
